<template>
	<div class="transaction">
		<!-- <FilterPanel @apply="page = 1; getDataPackage(20, 0)">
<div class="filter-field">
<label for="warehouse-transactionlist-f82">کاربر</label>
					<select id="warehouse-transactionlist-f82" v-model="pickCreator" class="form-select">
<option value="">همه</option>
						<option v-for="creator in creatorList" :value="creator.user.id" :key="creator.id">
							{{ creator.user.first_name }} {{ creator.user.last_name }}
						</option>
					</select>
</div>
<div class="filter-field">
<label for="warehouse-transactionlist-f83">تاریخ ویزیت</label>
					<input id="warehouse-transactionlist-f83" type="text" class="custom-input inputs" />
					<date-picker
						v-model="rangeDate"
						range
						clearable
						format="YYYY-MM-DDTHH:mm:00"
						display-format="jMMMM jD"
						custom-input=".custom-input"
					/>
</div>
<template #actions>
<button type="submit" class="accept">اعمال فیلتر</button>
<button type="button" class="remove-filtes" @click="removeFilter">پاک کردن فیلترها</button>
</template>
</FilterPanel> -->
		<div class="box list-box">
			<div>
				<Tableview
					:hover="true"
					:bordered="true"
					:showNoContent="showContnetFunc"
					:showNoData="showDataFunc"
				:recordCount="totalDataCount" :page="page">
<template #controls>
<label class="ordering-title">مرتب سازی بر اساس </label>
					<b-form-select
						v-model="selected"
						:options="options"
						class="ordering"
						value-field="item"
						text-field="name"
						@change="page = 1; getDataPackage(20, 0)"
					></b-form-select>
</template>
<template #footer>
<pagination
					v-model="page"
					:per-page="20"
					:records="totalDataCount"
					@paginate="myCallback"
				/>
</template>
					<template #TableTitle>
						<tr>
							<th>ردیف</th>
							<th>شناسه انتقال</th>
							<th>نوع انتقال</th>
							<th>کاربر</th>
							<th>انبار</th>
							<th>مقدار</th>
							<th>نام کالا</th>
							<th>تاریخ</th>
							<th>مجری</th>
						</tr>
					</template>

					<template #TableBody>
						<tr v-for="(item, index) in transactionLineList" :key="item.id">
							<td class="persian-number">
								{{ 20 * (page - 1) + 1 + index }}
							</td>
							<td class="persian-number">{{ item.transaction.id }}</td>
							<td>{{ kindLabel(item.transaction.movement_kind) || item.type?.verbose_name || 'گردش قدیمی' }}</td>
							<td v-if="item.user !== null">
								{{ item.user.first_name }} {{ item.user.last_name }}
							</td>
							<td v-else>-</td>
							<td v-if="item.location !== null">{{ item.location.name_fa }}</td>
							<td v-else>-</td>
							<td
								:class="{ negative: isNegative(item.amount), positive: !isNegative(item.amount) }"
								class="persian-number"
							>
								{{ item.amount }}
							</td>
							<td>{{ item.ware.name_fa }}</td>
							<td class="persian-number">
								<DisplayDate :value="item.transaction.datetime_created" showTime />
							</td>
							<td>
								{{ item.transaction.creator.first_name }} {{ item.transaction.creator.last_name }}
							</td>
							<td></td>
						</tr>
					</template>
				</Tableview>
			</div>
		</div>
	</div>
</template>
<script>
import Tableview from '../../components/Tableview/index.vue';
import Pagination from '@/components/ListPagination/index.vue';

import DisplayDate from '@/components/DisplayDate/index.vue';
export default {
	components: { DisplayDate,
		Tableview,
		Pagination,
	},
	data() {
		return {
			creatorList: [],
			transactionList: [],
			transactionLineList: 0,
			pickCreator: null,
			totalDataCount: 0,
			page: 1,
			rangeDate: [],
		};
	},
	mounted() {
		this.getCreatorLists();
		this.getTransactionLine();
	},
	computed: {
		showContnetFunc() {
			return this.transactionLineList === 0;
		},
		showDataFunc() {
			if (this.transactionLineList.length !== undefined) {
				return this.transactionLineList.length === 0;
			}
			return false;
		},
	},
	methods: {
		kindLabel(kind) {
			return ({ RECEIPT: 'دریافت', OPENING: 'موجودی افتتاحی', TRANSFER: 'انتقال',
				RETURN: 'برگشت به انبار', CONSUME: 'مصرف', SCRAP: 'ضایعات' })[kind] || '';
		},
		async getCreatorLists() {
			const res = await this.$ApiServiceLayer.get(
				this.$PATH.RELATIVE_PATH.GET.ROLE_ASSIGNMENT +
					'?p=' +
					this.$STORE.state.userConfig.setProjectId +
					'&role__title_abbreviation__in=V,S,M,F,P',
				this.$PATH.SERVICE_NAME.AUTH,
			);
			if (res.status === 200) {
				this.creatorList = res.data;
				console.log(res.data);
			}
		},
		async getTransactionLine(limit = 20, offset = 0) {
			const url = window.location.href;
			const lastParam = url.split('/').slice(-1)[0];
			const res = await this.$ApiServiceLayer.get(
				this.$PATH.RELATIVE_PATH.MULTI.TRANSACTION_LINE_LIST_CREATE +
					'?ware=' +
					lastParam +
					'&limit=' +
					limit +
					'&offset=' +
					offset +
					'&ordering=-transaction__datetime_created' +
					'&p=' +
					this.$STORE.state.userConfig.setProjectId,
				this.$PATH.SERVICE_NAME.EMPTY,
			);
			if (res.status === 200) {
				this.transactionLineList = res.data.results;
				this.totalDataCount = res.data.count;
			}
		},
		async myCallback() {
			await this.getTransactionLine(20, 20 * (this.page - 1));
		},
		isNegative(number) {
			return number < 0;
		},
	},
};
</script>
<style lang="scss" scoped>
.transaction {
	padding: 32px 50px;
	.box {
		// border: 1px solid var(--line-strong);
		padding: 24px;
		border-radius: 8px;
		margin-bottom: 16px;
		background: var(--surface);
		border-radius: 8px;
		box-shadow: none;
		.title {
			font-weight: 700;
			font-size: 18px;
		}
		.inputs {
			width: 100%;
			height: 38px;
			border: 1px solid var(--line-strong);
			padding: 0 9px;
			border-radius: 8px;
			font-family: 'IRANYekanfa' !important;
			border-radius: 8px;
		}
		.accept {
			height: 38px;
			background: var(--action);
			border-radius: 8px;
			color: var(--surface);
			border: none !important;
			margin-left: 10px;
			width: 50%;
			border-radius: 8px;
		}
		.remove-filtes {
			width: 50%;
			border: 1px solid var(--action);
			border-radius: 8px;
			color: var(--action);
			height: 38px;
			background: var(--surface);
			border-radius: 8px;
		}
		.form-select {
			width: 100%;
			border: 1px solid var(--line-strong);
			height: 38px;
			padding: 0 9px;
			border-radius: 8px;
			color: var(--text-3);
			border-radius: 8px;
		}
		.negative {
			color: red;
			font-weight: bold;
			direction: ltr;
		}
		.positive {
			color: green;
		}
	}
	.persian-number {
		font-family: 'IRANYekanfa' !important;
	}
}
</style>

<style>
.VuePagination__count {
	display: none;
}
.page-link {
	border: none;
	color: black;
	font-family: 'IRANYekanfa' !important;
}
.vpd-icon-btn {
	display: none !important;
}
.vpd-input-group input {
	border: none !important;
	border-radius: 0;
	font-family: 'IRANYekanfa';
}
.vpd-input-group input:disabled {
	background: var(--surface);
	text-align: center;
	min-width: 130px;
}
</style>
